module.exports = __webpack_public_path__ + "static/img/2.97cbc146.jpg";